import { Token } from '../types'

const { REACT_APP_API } = process.env

async function generateId(): Promise<{ success: boolean; data: any }> {
  let resp = await fetch(`${REACT_APP_API}/tokens/generate-id`, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  })

  const data = await resp.json()
  return { success: resp.ok, data }
}

async function getToken(id: string): Promise<{ success: boolean; data: any }> {
  let resp = await fetch(`${REACT_APP_API}/tokens/${id}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  })

  const data = await resp.json()
  return { success: resp.ok, data }
}

async function updateToken(
  token: Token,
  accessToken: string
): Promise<{ success: boolean; data: any }> {
  let resp = await fetch(`${REACT_APP_API}/tokens/${token.id}`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(token)
  })

  const data = await resp.json()
  return { success: resp.ok, data }
}

export const tokenService = {
  generateId,
  updateToken,
  getToken
}
